/**
 * Обёртка для вызова методов jQuery imView.
 */
class ImViewBridge {
    /**
     * Инициализация view в для режима совместимости
     * @param element Элемент для инициализации view
     */
    static initImView(element, options) {
        /*  if ((window as any).execInitView) {
              (window as any).execInitView(element, options);
          }*/
    }
    /**
     * Вызов глобального системного события (эмуляция legacy imsys.e.execEvent).
     * @param sender Элемент-отправитель (или null)
     * @param cmd Имя события
     * @param options Дополнительные параметры
     */
    static execEvent(sender, cmd, options) {
        const $ = window.$;
        const senderWrapped = sender && $ ? $(sender) : sender;
        // type = cmd подается тут
        const evt = new CustomEvent(cmd, { bubbles: true });
        // Эмулируем старый jQuery: кладём поля прямо на сам event
        evt.sender = senderWrapped;
        evt.cmd = cmd;
        evt.options = options;
        document.body.dispatchEvent(evt);
    }
    /**
     * Уничтожает легаси-экземпляр imView на указанном элементе.
     * Используется новым ViewWidget для совместимости.
     */
    static destroyView(element) {
        /* try {
             const $ = (window as any).$ as any | undefined;
             if (!$) return;
 
             const $view = $(element);
             if (typeof $view.imView === "function") {
                 $view.imView("destroy");
             }
         } catch (e) {
             console.error("Ошибка при уничтожении легаси imView:", e);
         }*/
    }
}

export { ImViewBridge };
